module.exports = __webpack_public_path__ + "static/media/bnr6.40ee0861.jpg";